import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-center flex-column-fluid p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("h1", null, "Chính sách bảo mật", -1),
    _createElementVNode("p", null, "Chúng tôi tôn trọng quyền riêng tư của bạn. Tin nhăn của bạn chỉ được lưu lại nhằm mục đích tối ưu hóa việc phản hồi", -1),
    _createElementVNode("p", null, "Chúng tôi không chia sẻ thông tin của bạn cho bên thứ ba nào.", -1),
    _createElementVNode("p", null, "Liên hệ với chúng tôi tại example@test.com .", -1)
  ])))
}